import * as actionsTypes from './types';
import { LinkParams, ImageState } from '../types';

export function toggleChat() {
  return {
    type: actionsTypes.TOGGLE_CHAT,
  };
}

export function toggleInputDisabled() {
  return {
    type: actionsTypes.TOGGLE_INPUT_DISABLED,
  };
}

export function toggleSendDisabled(cond) {
  return {
    type: actionsTypes.TOGGLE_SEND_DISABLED,
    cond,
  };
}

export function setWidgetConfig(data) {
  return {
    type: actionsTypes.SET_WIDGET_CONFIG,
    data,
  };
}

export function setLoadingMessages(cond) {
  return {
    type: actionsTypes.SET_LOADING_MESSAGES,
    cond,
  };
}

export function setIsChatFullScreen(cond) {
  return {
    type: actionsTypes.SET_IS_CHAT_FULL_SCREEN,
    cond,
  };
}

export function setSessionAvailable(cond) {
  return {
    type: actionsTypes.SET_SESSION_AVAILABLE,
    cond,
  };
}

export function setSessionStarted(cond) {
  return {
    type: actionsTypes.SET_SESSION_STARTED,
    cond,
  };
}

export function setShowSenderComponent(cond) {
  return {
    type: actionsTypes.SET_SHOW_SENDER_COMPONENT,
    cond,
  };
}

export function setRecentMessage(val) {
  return {
    type: actionsTypes.SET_RECENT_MESSAGE,
    val,
  };
}

export function addUserMessage(text, id) {
  return {
    type: actionsTypes.ADD_NEW_USER_MESSAGE,
    text,
    id,
  };
}

export function addResponseMessage(text, id) {
  return {
    type: actionsTypes.ADD_NEW_RESPONSE_MESSAGE,
    text,
    id,
  };
}

export function toggleMsgLoader(payload) {
  return {
    type: actionsTypes.TOGGLE_MESSAGE_LOADER,
    payload,
  };
}

export function addLinkSnippet(link, id) {
  return {
    type: actionsTypes.ADD_NEW_LINK_SNIPPET,
    link,
    id,
  };
}
export function renderMultipleComponent(component, props, showAvatar, id) {
  return {
    type: actionsTypes.ADD_HISTORY_MESSAGE,
    component,
    props,
    showAvatar,
    id,
  };
}
export function renderHistoryComponent(component, props, showAvatar, id) {
  return {
    type: actionsTypes.ADD_HISTORY_COMPONENT,
    component,
    props,
    showAvatar,
    id,
  };
}
export function renderCustomComponent(component, props, showAvatar, id) {
  return {
    type: actionsTypes.ADD_COMPONENT_MESSAGE,
    component,
    props,
    showAvatar,
    id,
  };
}

export function dropMessages() {
  return {
    type: actionsTypes.DROP_MESSAGES,
  };
}

export function hideAvatar(index) {
  return {
    type: actionsTypes.HIDE_AVATAR,
    index,
  };
}

export function setQuickButtons(buttons) {
  return {
    type: actionsTypes.SET_QUICK_BUTTONS,
    buttons,
  };
}

export function deleteMessages(count, id) {
  return {
    type: actionsTypes.DELETE_MESSAGES,
    count,
    id,
  };
}

export function deleteLastMessage() {
  return {
    type: actionsTypes.DELETE_LAST_MESSAGE,
  };
}

export function setTotalMessageCount(count) {
  return {
    type: actionsTypes.SET_TOTAL_MESSAGE_COUNT,
    count,
  };
}

export function setBadgeCount(count) {
  return {
    type: actionsTypes.SET_BADGE_COUNT,
    count,
  };
}

export function markAllMessagesRead() {
  return {
    type: actionsTypes.MARK_ALL_READ,
  };
}

export function openFullscreenPreview(payload) {
  return {
    type: actionsTypes.OPEN_FULLSCREEN_PREVIEW,
    payload,
  };
}

export function closeFullscreenPreview() {
  return {
    type: actionsTypes.CLOSE_FULLSCREEN_PREVIEW,
  };
}

export function resetMessages(value) {
  return {
    type: actionsTypes.RESET_MESSAGES,
    value,
  };
}
